import * as React from "react";

const SvgIcnDebuggerWarning = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 28 28" fill="none" {...props}>
        <path
            d="M15.042 8.375h-6.5c-.645 0-1.167.522-1.167 1.167v7.041c0 .645.522 1.167 1.167 1.167h4.927v.781h-1.813a.625.625 0 000 1.25h4.875a.625.625 0 000-1.25H14.72v-.781h4.927c.644 0 1.166-.522 1.166-1.167V12.2h-1.25v4.3H8.626V9.625h5.707c.035-.086.077-.172.127-.256l.583-.994z"
            fill="#fff"
        />
        <path
            d="M14.426 11.203l-1.357 2.716-.969-1.452a.829.829 0 00-.688-.368h-1.01a.625.625 0 100 1.25h.784l1.246 1.868a.828.828 0 001.429-.088l1.533-3.067a1.933 1.933 0 01-.968-.86zM16.108 12.2l.52.78a.828.828 0 00.69.369h.396a.625.625 0 00.34-1.149h-1.946z"
            fill="#fff"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.678 9.875l-3.89-6.629a.922.922 0 00-1.578 0l-3.89 6.629c-.346.59.092 1.325.79 1.325h7.779c.698 0 1.136-.735.79-1.325zM19.993 5.8h.012c.367.004.644.355.587.746l-.257 1.343c-.024.178-.167.311-.334.311h-.004c-.167 0-.31-.133-.334-.31l-.256-1.344c-.057-.39.224-.746.586-.746zM20 10a.6.6 0 100-1.2.6.6 0 000 1.2z"
            fill="#E36A19"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.789 3.246l3.89 6.629c.346.59-.092 1.325-.79 1.325h-7.78c-.697 0-1.135-.735-.789-1.325l3.89-6.629a.922.922 0 011.579 0zm-.78 2.554h-.013c-.362 0-.643.355-.586.746l.256 1.343c.025.178.167.311.334.311h.004c.167 0 .31-.133.334-.31l.257-1.344c.057-.39-.22-.742-.587-.746zm.593 3.6a.6.6 0 11-1.2 0 .6.6 0 011.2 0z"
            fill="#F47C22"
        />
    </svg>
);

export default SvgIcnDebuggerWarning;
